import { Injectable } from '@angular/core';
import { CanLoad, Route, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthGuard implements CanLoad {

    constructor(
        private _userService: UserService,
        private router: Router
    ) {}

    canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
        const auth = this._userService.isUserLogged();
        if (!auth) {
            this.router.navigate(['/login']);
            return false;
        } else {
            return true;
        }
    }
}
